import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectorRef, NgZone } from '@angular/core';
import { FileService } from 'src/app/services/file/file.service';
import { UploadComponent } from "./upload/upload.component";
import { SpinnerComponent } from "../spinner/spinner.component";
import { FolderCreateComponent } from "./folder-create/folder-create.component";

@Component({
  selector: 'app-file-manager',
  imports: [CommonModule, UploadComponent, SpinnerComponent, FolderCreateComponent],
  templateUrl: './file-manager.component.html',
  styleUrl: './file-manager.component.css'
})
export class FileManagerComponent {
  @Input() type: 'image' | 'file' = 'image';
  @Input() multiple = false;
  @Output() fileSelected = new EventEmitter<string>();
  @Output() multipleFilesSelected = new EventEmitter<string[]>();

  @Input() allowedFiles: string[] = [];

  fileList: string[] = [];
  fileTree: any[] = [];
  pathStack: { tree: any[]; path: string }[] = [];
  currentFolderPath: string = ''; 

  load = false


  @Input() multiselect: boolean = false;

  selectedFiles: string[] = [];

  constructor(
    private FileService: FileService,
    private cd: ChangeDetectorRef,
    private zone: NgZone
  ){
    this.getFiles()
  }


  getFiles(path: string = '') {
    this.load = true;
    this.FileService.getFiles(path).subscribe(
      (data: any) => {
        this.zone.run(() => {
          // console.log(data)
              if (this.allowedFiles && this.allowedFiles.length) {

            // ✅ ვიღებთ მხოლოდ ფაილის სახელს (4G3A8409.JPG)
            const allowedNames = this.allowedFiles.map(f => {
              const clean = f.split('?')[0];
              return clean.substring(clean.lastIndexOf('/') + 1);
            });

            // console.log('ALLOWED FILENAMES:', allowedNames);

            const flattenFiles = (items: any[], acc: any[] = []) => {
              for (const item of items) {
                if (item.type === 'file') {
                  acc.push(item);
                }
                if (item.type === 'folder' && Array.isArray(item.children)) {
                  flattenFiles(item.children, acc);
                }
              }
              return acc;
            };

            const allFiles = flattenFiles(data);

            // console.log('ALL FILES FLATTENED:', allFiles);

            data = allFiles.filter(file =>
              allowedNames.includes(file.name)
            );

            // console.log('FINAL FILTERED FILES:', data);
          }

          this.fileTree = data;
          this.load = false;
          this.cd.detectChanges();
        });
      },
      (error: any) => {
        console.log(error);
        this.zone.run(() => {
          this.load = false;
          this.cd.detectChanges();
        });
      }
    );
  }

  onUploadComplete() {
    this.getFiles(this.currentFolderPath);
  }


  selectFile(file: string) {
    if (this.multiselect) {
      this.selectMultipleFile(file);
    } else {
      this.fileSelected.emit(file);
    }
  }

  selectMultipleFile(file: string) {
    const index = this.selectedFiles.indexOf(file);
    if (index === -1) {
      this.selectedFiles.push(file);
    } else {
      this.selectedFiles.splice(index, 1);
    }

    this.multipleFilesSelected.emit(this.selectedFiles);
  }


  isImageFile(name: string): boolean {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(name);
  }

  openFolder(folder: any) {
    this.pathStack.push({ tree: this.fileTree, path: this.currentFolderPath });
    this.currentFolderPath += `/${folder.name}`;
    this.getFiles(this.currentFolderPath);
  }

  goBack() {
    if (this.pathStack.length > 0) {
      const previous = this.pathStack.pop()!;
      this.currentFolderPath = previous.path;
      this.getFiles(this.currentFolderPath);
    }
  }

delete(item: any) {
  if (!confirm(`დარწმუნებული ხარ რომ გინდა წაშალო "${item.name}"?`)) return;

  this.load = true;
  const payload = {
    path: item.path,
    type: item.type
  };

  this.FileService.deleteItem(payload).subscribe(
    (res: any) => {
      this.getFiles(this.currentFolderPath);
      this.load = false;
      console.log(res)
    },
    (error: any) => {
      console.error('შეცდომა წაშლის დროს:', error);
      this.load = false;
    }
  );
}

}
